<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="showDepartmentModal(null)"
                            type="button">
                        <icon name="plus"></icon> เพิ่มแผนก
                    </button>
                    &nbsp;
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">แผนก</th>
                    <th scope="col">แก้ไข/ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in departmentList">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.department_name}}</td>
                    <td>
                        <a @click="showDepartmentModal(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="departmentList.length > 0">
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getDepartmentList">
        </vue-pagination>
    </div>
        <br>
        <!-- ----Modal Add Social Security---- -->
        <b-modal hide-header hide-footer ref="add_department">
            <div style="text-align: center;">
                <h4>เพิ่มแผนก</h4>
                <br />
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>แผนก</label>
                    </b-col>
                    <b-col sm="5" class="col-sm-5">
                        <input v-model="form.department_name"
                               type="text" class="form-control"/>
                    </b-col>
                </div>

                <button @click="saveDepartment"
                        type="button"
                        class="btn btn-success mt-2">
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button
                        type="button"
                        @click="hideDepartmentModal"
                        class="btn btn-outline-secondary mt-2">
                    ยกเลิก
                </button>
            </div>
        </b-modal>

        <!-- ----Modal delete Social Security---- -->
        <b-modal hide-header hide-footer ref="delete_modal">
            <div style="text-align: center;">
                <h4>คุณต้องการลบสิ่งนี้ใช่หรือไม่?</h4>
                <br />
                <button @click="deleteDepartment"
                        type="button"
                        class="btn btn-success mt-2">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                        type="button"
                        @click="hideDeleteModal"
                        class="btn btn-outline-secondary mt-2">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import Multiselect from "vue-multiselect"
    import VuePagination from "../../../Pagination";
    import moment from "moment";
    import DatePicker from 'vue2-datepicker'

    export default {
        name: "department-list",
        components: {
            Multiselect,
            VuePagination,
            DatePicker
        },
        created(){
            this.$store.dispatch("Department/setDepartment");
        },
        data() {
            return {

            };
        },
        computed:{
            ...mapState({
                departmentList : state=>{
                    return state.Department.departmentList;
                },
                dataPaginate:state=>{
                    return state.Department.dataPaginate;
                },
                form:state=>{
                    return state.Department.form;
                },
            }),
        },
        methods:{
            hideDepartmentModal(){
                this.$refs.add_department.hide();
            },
            showDepartmentModal(id) {
                this.form.id = id

                if(this.form.id!= null){
                    this.$store.dispatch("Department/showDepartmentByID",this.form.id).then(data =>{
                        this.$refs.add_department.show();
                    });
                }
                else{
                    this.$store.dispatch("Department/clearFormData").then(data =>{
                        this.$refs.add_department.show();
                    });
                }
            },
            hideDeleteModal(){
                this.$refs.delete_modal.hide();
            },
            showDeleteModal(id) {
                this.form.id = id;
                this.$refs.delete_modal.show();
            },
            deleteDepartment(){
                this.$store.dispatch("Department/delete",this.form.id).then(data =>{
                    this.$store.dispatch("Department/setDepartment");
                });
                this.hideDeleteModal();
                this.$store.dispatch("Department/clearFormData");
            },
            saveDepartment(){
                if(!this.form.department_name){
                    alert('กรุณากรอกแผนก')
                }
                else{
                    this.$store.dispatch("Department/saveDepartment",this.form).then(data =>{
                        this.$store.dispatch("Department/setDepartment");
                    });

                }
                this.hideDepartmentModal();
                this.$store.dispatch("Department/clearFormData");
            },
            getDepartmentList(){
                const page = this.dataPaginate.current_page;

                //paginate get data
                this.$store.dispatch("Department/setDepartment",page);
            }

        }
    }
</script>

<style scoped>

</style>
